import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    FaBoxOpen,
    FaUserShield,
    FaArrowRight,
    FaChevronDown,
    FaCogs,
    FaFolderOpen,
    FaAddressCard,
    FaHistory
} from 'react-icons/fa';
import styles from './Administracion.module.css';

const Administracion = () => {
    const [activosOpen, setActivosOpen] = useState(true); // default open for assets
    const [usuariosOpen, setUsuariosOpen] = useState(false);
    const [ticketsOpen, setTicketsOpen] = useState(false);
    const [consumosOpen, setConsumosOpen] = useState(false);

    const toggleActivos = () => {
        setActivosOpen(!activosOpen);
        setUsuariosOpen(false);
        setTicketsOpen(false);
        setConsumosOpen(false);
    };

    const toggleUsuarios = () => {
        setUsuariosOpen(!usuariosOpen);
        setActivosOpen(false);
        setTicketsOpen(false);
        setConsumosOpen(false);
    };

    const toggleConsumo = () => {
        setConsumosOpen(!consumosOpen);
        setActivosOpen(false);
        setUsuariosOpen(false);
        setTicketsOpen(false);
    };

    const toggleTickets = () => {
        setTicketsOpen(!ticketsOpen);
        setActivosOpen(false);
        setUsuariosOpen(false);
        setConsumosOpen(false);
    };

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h2 className={styles.title}>
                    <FaUserShield style={{ marginRight: '15px' }} />
                    Área de Administración
                </h2>
                <p className={styles.subtitle}>Gestión centralizada de activos, usuarios y configuraciones maestras.</p>
            </header>

            <div className={styles.menuGrid}>
                {/* Gestión de Activos */}
                <div className={`${styles.sectionCard} ${styles.activos} ${activosOpen ? styles.isOpen : ''}`}>
                    <button className={styles.sectionHeader} onClick={toggleActivos}>
                        <div className={styles.headerLeft}>
                            <div className={styles.iconWrapper}>
                                <FaBoxOpen />
                            </div>
                            <span className={styles.sectionTitle}>Gestión de Activos</span>
                        </div>
                        <FaChevronDown className={styles.chevron} />
                    </button>
                    <div className={styles.sectionContent}>
                        <div className={styles.linkList}>
                            <Link to="/addactivo" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Crear activo
                            </Link>
                            <Link to="/administ" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Asignar Activo
                            </Link>
                            <Link to="/darbaja" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Dar De Baja activo
                            </Link>
                            <Link to="/administ" className={styles.menuLink}>
                                <FaArrowRight style={{ marginRight: '10px', fontSize: '0.8rem' }} />
                                Gestión salida de equipo/herramientas
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Gestión de Usuarios - DESHABILITADO */}
                <div className={`${styles.sectionCard} ${styles.usuarios} ${styles.disabledSection}`}>
                    <div className={styles.sectionHeader}>
                        <div className={styles.headerLeft}>
                            <div className={styles.iconWrapper}>
                                <FaAddressCard />
                            </div>
                            <span className={styles.sectionTitle}>Maestros de Usuarios (Solo Lectura)</span>
                        </div>
                        <span className={styles.lockedBadge}>Bloqueado</span>
                    </div>
                </div>

                {/* Servicios y Tickets - DESHABILITADO */}
                <div className={`${styles.sectionCard} ${styles.servicios} ${styles.disabledSection}`}>
                    <div className={styles.sectionHeader}>
                        <div className={styles.headerLeft}>
                            <div className={styles.iconWrapper}>
                                <FaFolderOpen />
                            </div>
                            <span className={styles.sectionTitle}>Servicios Globales</span>
                        </div>
                        <span className={styles.lockedBadge}>Bloqueado</span>
                    </div>
                </div>

                {/* Configuración - DESHABILITADO */}
                <div className={`${styles.sectionCard} ${styles.config} ${styles.disabledSection}`}>
                    <div className={styles.sectionHeader}>
                        <div className={styles.headerLeft}>
                            <div className={styles.iconWrapper}>
                                <FaCogs />
                            </div>
                            <span className={styles.sectionTitle}>Configuración y Otros</span>
                        </div>
                        <span className={styles.lockedBadge}>Bloqueado</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Administracion;
